<template>
  <b-overlay
    id="overlay-background"
    :show="loader"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-row>
      <b-col
        md="5"
        lg="5"
        offset-lg="3"
      >
        <b-card
          no-body
        >
          <b-card-body>
            <validation-observer
              ref="refInstallmentPlan"
            >
              <b-form>
                <b-row>
                  <b-col>
                    <div
                      class="amount-period-base-divs"
                    >
                      <b-col
                        class="optionsClass"
                        md="12"
                      >
                        <b-form-checkbox
                          v-model="bc_setting_values.amount_base_plan"
                          :value="1"
                          :unchecked-value="0"
                          class="custom-control-primary"
                        >
                          {{ $t('DEBTIA_AMOUNT_BASE_PLAN') }}
                        </b-form-checkbox>
                      </b-col>
                      <b-col
                        v-if="bc_setting_values.amount_base_plan"
                        md="12"
                      >
                        <b-form-group
                          :label="$t('DEBTIA_MIN_AMOUNT')"
                          label-for="min-amount"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="Min. Amount"
                            rules="required"
                          >
                            <b-form-input
                              id="min-amount"
                              v-model="bc_setting_values.min_amount"
                              type="number"
                              placeholder="Min. Amount"
                              :state="errors.length > 0 ? false:null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                    </div>
                    <div
                      class="amount-period-base-divs"
                    >
                      <b-col
                        class="optionsClass"
                        md="12"
                      >
                        <b-form-checkbox
                          v-model="bc_setting_values.period_base_plan"
                          :value="1"
                          :unchecked-value="0"
                          class="custom-control-primary"
                        >
                          {{ $t('DEBTIA_PERIOD_BASE_PLAN') }}
                        </b-form-checkbox>
                      </b-col>
                      <b-col
                        v-if="bc_setting_values.period_base_plan"
                        md="12"
                      >
                        <b-form-group
                          :label="$t('DEBTIA_MAX_MONTH')"
                          label-for="max-month"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="Max. Months"
                            rules="required"
                          >
                            <b-form-input
                              id="max-month"
                              v-model="bc_setting_values.max_amount"
                              type="number"
                              placeholder="Max. Month"
                              :state="errors.length > 0 ? false:null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                    </div>
                    <b-col
                      v-if="bc_setting_values.amount_base_plan || bc_setting_values.period_base_plan"
                      md="12"
                      class="interestDiv"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_INTEREST_FREE_MONTHS')"
                        label-for="interest-free-months"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Interest Free Months"
                          rules="required"
                        >
                          <b-form-input
                            id="interest-free-months"
                            v-model="bc_setting_values.interest_free_months"
                            type="number"
                            placeholder="Interest Free Months"
                            :state="errors.length > 0 ? false:null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <div
                      class="amount-period-base-divs"
                    >
                      <b-col
                        class="optionsClass"
                        md="12"
                      >
                        <strong>{{ $t('DEBTIA_UNPAID_INSTALLMENT_ACTIONS') }}</strong>
                      </b-col>
                      <b-col
                        md="12"
                      >
                        <b-form-group
                          :label="$t('DEBTIA_TEN_DAYS_ACTION')"
                          label-for="tendays-action"
                        >
                          <v-select
                            v-model="bc_setting_values.ten_days_action"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="processes"
                            :reduce="val => val.value"
                            :clearable="true"
                            input-id="tendays-action"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        md="12"
                      >
                        <b-form-group
                          :label="$t('DEBTIA_THIRTEEN_DAYS_ACTION')"
                          label-for="max-month"
                        >
                          <v-select
                            v-model="bc_setting_values.thirteen_days_action"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="processes"
                            :reduce="val => val.value"
                            :clearable="true"
                            input-id="thirteendays-action"
                          />
                        </b-form-group>
                      </b-col>
                    </div>
                  </b-col>
                </b-row>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  block
                  variant="primary"
                  class="ml-1"
                  @click="installmentSettings"
                >
                  Save
                </b-button>
              </b-form>
            </validation-observer>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BForm, BOverlay, BFormInput, BFormCheckbox, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import axios from '@axios'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BForm,
    BOverlay,
    BFormInput,
    BFormCheckbox,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    settings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      processes: [],
      loader: false,
      required,
      bc_setting_values: {
        min_amount: 0,
        max_amount: 0,
        amount_base_plan: 0,
        period_base_plan: 0,
        interest_free_months: 0,
        ten_days_action: 0,
        thirteen_days_action: 0,
      },
    }
  },
  watch: {
    settings: {
      handler() {
        this.mapValues()
      },
    },
  },
  created() {
    this.getProcesses()
  },
  methods: {
    normalizeValue(val) {
      return !Number.isNaN(val) && val !== '' ? Number(val) : val
    },
    normalizeObject(obj) {
      const result = {}
      Object.keys(obj).forEach(key => {
        result[key] = this.normalizeValue(obj[key])
      })
      return result
    },
    mapValues() {
      Object.keys(this.bc_setting_values).forEach(element => {
        const item = this.settings.filter(word => word.key === element)
        if (item.length > 0) {
          this.bc_setting_values[element] = item[0].value
        }
      })
      this.bc_setting_values = this.normalizeObject(this.bc_setting_values)
    },
    async getProcesses() {
      const url = '/process/get-processes-dropdown?type=secondary'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.processes = response.data.data.processes
        }
      })
    },
    installmentSettings() {
      const obj = [{
        key: 'min_amount',
        value: this.bc_setting_values.min_amount,
      },
      {
        key: 'max_amount',
        value: this.bc_setting_values.max_amount,
      },
      {
        key: 'amount_base_plan',
        value: this.bc_setting_values.amount_base_plan,
      },
      {
        key: 'period_base_plan',
        value: this.bc_setting_values.period_base_plan,
      },
      {
        key: 'interest_free_months',
        value: this.bc_setting_values.interest_free_months,
      },
      {
        key: 'ten_days_action',
        value: this.bc_setting_values.ten_days_action ?? 0,
      },
      {
        key: 'thirteen_days_action',
        value: this.bc_setting_values.thirteen_days_action ?? 0,
      }]
      this.$refs.refInstallmentPlan.validate().then(success => {
        if (success) {
          this.loader = true
          axios.post('user-settings/save', obj).then(response => {
            if (response.status) {
              this.loader = false
              this.makeSuccessToast()
            }
          }).catch(error => {
            this.loader = false
            this.makeFailureToast(error)
          })
        }
      })
    },
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    makeFailureToast(error) {
      this.$bvToast.toast(error.response.data.message, {
        title: 'Failed',
        variant: 'danger',
        solid: false,
      })
    },
  },
}
</script>

 <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .optionsClass {
    margin-bottom: 10px;
  }

  .amount-period-base-divs {
    width: 100%;
    padding: 15px 0px 5px 0px;
    border: 1px solid #d8d6dd;
    margin: 0px 15px 15px 15px;
    border-radius: 10px;
  }
    .interestDiv {
    margin-left: 10px;
  }
  .plan-container {
    border: 1px solid #3b4253 !important;
    border-radius: 10px !important;
  }
  </style>
